export class TransactionsTableHeaders
{
    public static readonly Revenue = 'Revenue Report';
    public static readonly GuaranteedPay = 'Guaranteed Pay';
    public static readonly TopUps = 'Top Ups';
    public static readonly CashOut = 'Cash Out';
    public static readonly CustomerXpayWallet = 'Customer Xpay Wallet';
    public static readonly DriverWallet = 'Driver Wallet';
    public static readonly Collection = 'Collection';
    public static readonly PendingCollection = 'Pending Collection';
    public static readonly Commerce = 'Commerce';
    public static readonly DriverCommerce = 'Driver Commerce';
    public static readonly CustomerCommerce = 'Customer Commerce';
}
